import React from 'react';
import { ProjectDiv } from './projectStyle';
import view from '../../assets/icons/eye-solid.svg';
import useElementOnScreen from '../../utils/useElementOnScreen';
import useSecElementOnScreen from '../../utils/useSecElementOnScreen';

const Projects = ({ lightBox, layoutIndex, projectData }) => {
  const [itemRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  });
  const [itemTwoRef, isInView] = useSecElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  });

  const handleOnclick = () => {
    lightBox(projectData.preview);
  };

  return (
    <ProjectDiv isVisible={isVisible} isInView={isInView}>
      <div
        className={
          layoutIndex % 2 !== 0 ? 'project-image-left' : 'project-image-right'
        }
        ref={itemRef}
      >
        <img src={projectData.image} alt='project' />
        <div className='project-overlay'>
          <div className='view' onClick={handleOnclick}>
            <img src={view} alt='see' />
            <p>view</p>
          </div>
        </div>
      </div>
      <div
        className={
          layoutIndex % 2 !== 0
            ? 'project-content-left'
            : 'project-content-right'
        }
        ref={itemTwoRef}
      >
        <div>
          <p className='project-overline'>{projectData.role}</p>
          <h3 className='project-title'>
            <a
              href={projectData.links.live_link}
              rel='noopener noreferrer'
              target='_blank'
            >
              {projectData.name}
            </a>
          </h3>
          <div className='project-description'>
            <p>{projectData.about}</p>
          </div>
          <ul className='project-tech-list'>
            {projectData.tech.map((stack, index) => (
              <li key={stack + index}>{stack}</li>
            ))}
          </ul>
          <div className='project-links'>
            <a
              href={projectData.links.repo}
              aria-label='GitHub Link'
              rel='noopener noreferrer'
              target='_blank'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                role='img'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                class='feather feather-github'
              >
                <title>GitHub</title>
                <path d='M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22'></path>
              </svg>
              <p>Source code</p>
            </a>
            <a
              href={projectData.links.live_link}
              aria-label='External Link'
              class='external'
              rel='noopener noreferrer'
              target='_blank'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                role='img'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                class='feather feather-external-link'
              >
                <title>External Link</title>
                <path d='M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6'></path>
                <polyline points='15 3 21 3 21 9'></polyline>
                <line x1='10' y1='14' x2='21' y2='3'></line>
              </svg>
              <p>Live preview</p>
            </a>
          </div>
        </div>
      </div>
    </ProjectDiv>
  );
};

export default Projects;
